
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetType = typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetType[keyof typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
